
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M124.256 211.482c48.602-2.224 87.323-42.331 87.323-91.482 0-49.151-38.721-89.258-87.323-91.482V57h34.117c5.321 0 9.634 4.316 9.634 9.632v102.511a9.63 9.63 0 01-9.634 9.632h-34.117v32.707zm-8.256.011C67.278 209.399 28.421 169.237 28.421 120c0-49.237 38.857-89.399 87.579-91.493V57H80.634A9.63 9.63 0 0071 66.632v102.511c0 5.316 4.313 9.632 9.634 9.632H116v32.718zM20 120C20 64.772 64.772 20 120 20s100 44.772 100 100-44.772 100-100 100S20 175.228 20 120zm59.256-53.368v102.511c0 .758.618 1.376 1.378 1.376h77.739c.764 0 1.378-.614 1.378-1.376V66.632c0-.758-.618-1.376-1.378-1.376H80.634c-.764 0-1.378.614-1.378 1.376zM88 134v-30h5.05l5.644 15.722L104.495 104h4.857v30h-4.438v-20.237l-4.386 12.447h-3.791l-4.264-12.325V134H88zm24.358 0l7.81-30h4.578l8.474 30h-4.892l-1.765-6.915h-8.003L116.901 134h-4.543zm7.338-11.695h5.662l-2.936-11.471-2.726 11.471zM133.57 134l7.304-15.58-6.588-14.42h5.05l4.071 9.254 4.229-9.254h4.683l-6.57 14.054L153 134h-4.997l-4.805-10.739L138.27 134h-4.7zm63.061-11.007l-8.346 9.532a3.893 3.893 0 01-5.495.365 3.892 3.892 0 01-.365-5.496l6.1-6.967-6.1-6.968a3.877 3.877 0 01-.965-2.563 3.894 3.894 0 016.825-2.567l8.346 9.532a3.896 3.896 0 010 5.132zm-152.667 0l8.346 9.532a3.893 3.893 0 005.495.365 3.892 3.892 0 00.365-5.496l-6.1-6.967 6.1-6.968a3.877 3.877 0 00.965-2.563 3.894 3.894 0 00-6.825-2.567l-8.346 9.532a3.896 3.896 0 000 5.132z"}})])
          )
        }
      }
    